module.exports = __webpack_public_path__ + "static/DINPro-Bold-3b3741f8ad8c1c0dbf4d5f4a68728d16.woff";